import axios from 'axios';
import { environment } from '../environment';

const PAYMENT_API_URL = environment.REACT_APP_PAYMENTS_API_URL;

export interface PaymentOrder {
  id: string;
  amount: number;
  currency: string;
  receipt: string;
}

export interface PaymentOrderRequest {
  amount: number;
  currency?: string;
  receipt?: string;
  notes?: {
    plan_type?: string;
    timestamp?: string;
  };
}

export interface PaymentVerificationRequest {
  order_id: string;
  payment_id: string;
  signature: string;
}

export interface PaymentVerificationResponse {
  success: boolean;
  payment_id?: string;
  order_id?: string;
  verified?: boolean;
  message?: string;
  error?: string;
}

export interface SubscriptionPlan {
  type: string;
  name: string;
  price: number;
  duration: string;
  description: string;
  features: string[];
  isSubscription: boolean;
}

export const paymentService = {
  createOrder: async (orderData: PaymentOrderRequest): Promise<{ success: boolean; order: PaymentOrder }> => {
    const response = await axios.post(`${PAYMENT_API_URL}/api/create-order`, orderData);
    return response.data;
  },

  verifyPayment: async (paymentData: PaymentVerificationRequest): Promise<PaymentVerificationResponse> => {
    const response = await axios.post(`${PAYMENT_API_URL}/api/verify-payment`, paymentData);
    return response.data;
  },

  getPaymentDetails: async (paymentId: string): Promise<any> => {
    const response = await axios.get(`${PAYMENT_API_URL}/api/payment/${paymentId}`);
    return response.data;
  },

  getSubscriptionPlans: (): SubscriptionPlan[] => [
    {
      type: 'daily_pass',
      name: 'Daily Pass',
      price: 10,
      duration: 'per day',
      description: 'Unlimited access for 24 hours',
      features: ['All premium features', '24-hour access'],
      isSubscription: true
    },
    {
      type: 'weekly_pass',
      name: 'Weekly Pass',
      price: 49,
      duration: 'per week',
      description: 'Unlimited access for 7 days',
      features: ['All premium features', '7-day access', 'Best value for short term'],
      isSubscription: true
    },
    {
      type: 'monthly_pass',
      name: 'Monthly Pass',
      price: 99,
      duration: 'per month',
      description: 'Unlimited access for 30 days',
      features: ['All premium features', '30-day access', 'Save 60% vs daily'],
      isSubscription: true
    },
    {
      type: 'quarterly_pass',
      name: 'Quarterly Pass',
      price: 199,
      duration: 'per 3 months',
      description: 'Unlimited access for 90 days',
      features: ['All premium features', '90-day access', 'Save 67% vs monthly'],
      isSubscription: true
    },
    {
      type: 'yearly_pass',
      name: 'Yearly Pass',
      price: 999,
      duration: 'per year',
      description: 'Unlimited access for 365 days',
      features: ['All premium features', '365-day access', 'Save 83% vs monthly', 'Priority support'],
      isSubscription: true
    }
  ]
};
